'use strict';

export default function f() {
  return function(input) {
    input = input || '';
    return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/title_case.filter.js